import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

interface ToggleEnrollmentBalanceBypassCommand {
  enrollmentId: string;
  enabled: boolean;
}

export const toggleEnrollmentBalanceBypass = createApiThunk<void, ToggleEnrollmentBalanceBypassCommand>(
  "admin/toggleEnrollmentBalanceBypass",
  async ({ enrollmentId, enabled }, { extra: { adminRepository } }) => {
    return adminRepository!.setEnrollmentBalanceBypass(enrollmentId, enabled);
  },
);

export const resetToggleEnrollmentBalanceBypass = createAction("admin/resetToggleEnrollmentBalanceBypass");
